import { Link } from "react-router-dom";
import styled from "styled-components/macro";

import { buttonVariants } from "../../../probate/components/ui/button";

// A router link styled as Mark's outline Button, as shadcn styles a link with buttonVariants
const ButtonLink = styled(Link).attrs({ "data-slot": "button", "data-variant": "outline", "data-size": "default" })`
  ${buttonVariants}
`;

export default ButtonLink;
